<template>
  <div class="FormFactList">
    <FieldList
      :isCheckable="canMerge"
      :items="items"
      :itemsChecked="itemsChecked"
      :labels="labels"
      type="textarea"
      @add="addItem"
      @check="check"
      @update:items="setItems">
      <template v-if="isCustom" #field="{ item, removeItem, setItem }">
        <FormRecommendation
          v-if="factTemplate.type === 'RECOMMENDATIONS_ALL'"
          :item="item"
          @remove="removeItem"
          @update:item="setItem" />
        <FormRequirement
          v-else-if="factTemplate.type === 'REQUIREMENTS_ALL'"
          :item="item"
          @remove="removeItem"
          @update:item="setItem" />
        <FormRelatedArticle
          v-else-if="factTemplate.type === 'RELATED_ARTICLES'"
          :item="item"
          @remove="removeItem"
          @update:item="setItem" />
        <FormSource
          v-else-if="factTemplate.type === 'SOURCES'"
          :item="item"
          @remove="removeItem"
          @update:item="setItem" />
      </template>
      <RowFlex slot="foot" class="constrainButtons">
        <Btn
          class="sm"
          :disabled="!!(canMerge && items.length && !itemsDismissed.length)"
          :isLoading="isCreating"
          @click="upsert">
          {{ doesExist ? $t('regenerate') : $t('generate') }}
        </Btn>
        <template v-if="items.length">
          <Btn
            class="sm fancy"
            :class="{ inv: !fact.likedAt }"
            icon="star"
            @click="toggleTimestamp('likedAt')">
            {{ $t('exemplary') }}
          </Btn>
        </template>
      </RowFlex>
    </FieldList>
  </div>
</template>

<script>
import { FACT_TYPES } from '@store/modules/fact'
import FieldList from '@forms/FieldList'
import FormRecommendation from './FormRecommendation'
import FormRelatedArticle from './FormRelatedArticle'
import FormRequirement from './FormRequirement'
import FormSource from './FormSource'
import ResearchFact from '../ResearchFact'
import { actions } from '@utils'

export default {
  mixins: [
    ResearchFact(FACT_TYPES.KEY_POINTS),
  ],
  components: {
    FieldList,
    FormRecommendation,
    FormRelatedArticle,
    FormRequirement,
    FormSource,
  },
  props: {
    section: Object,
    sectionTemplate: Object,
  },
  computed: {
    isCustom() {
      return [
        FACT_TYPES.RECOMMENDATIONS_ALL,
        FACT_TYPES.RELATED_ARTICLES,
        FACT_TYPES.REQUIREMENTS_ALL,
        FACT_TYPES.SOURCES,
      ].includes(this.factTemplate.type)
    },
  },
  methods: {
    considerDeleting(index) {
      const value = this.items[index]

      if (!value) return this.removeItem(index)
    },
    async setBoolean(key, value) {
      await this.PATCH_FACT({
        id: this.fact.id,
        [key]: value,
      })

      this.$up('fact', {
        ...this.fact,
        [key]: value,
      })
    },
    async toggleTimestamp(key) {
      const timestamp = this.fact[key]
        ? null
        : new Date()

      await this.PATCH_FACT({
        id: this.fact.id,
        [key]: timestamp,
      })

      this.$up('fact', {
        ...this.fact,
        [key]: timestamp,
      })
    },
    ...actions('PATCH_FACT'),
  },
}
</script>

<style lang="scss">
.FormFactList {
}
</style>

<i18n>
{
  "en": {
    "add": "Add a point",
    "exemplary": "Exemplary",
    "generate": "Generate",
    "regenerate": "Regenerate"
  }
}
</i18n>
